import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";

export const flushErrors = () => {
  return {
    type: ReduxActionTypes.FLUSH_ERRORS,
  };
};
